import Accordion from "../../../../../components/Accordion";
import FormInput from "../../../../../components/Form/FormInput";
import FormSelectBox from "../../../../../components/Form/FormSelectBox";
import { EmpresaSupervisora } from "../../../../../types/EmpresaSupervisora";
import { useUserLogin } from "../../../../../hooks/useUserLogin";
import { FormEmpresaSupervisoraErrors, mailConFormatoInvalido } from "..";


type EmpresaSupervisoraProps = {
    empresaSupervisoraForm: EmpresaSupervisora;
    errors: FormEmpresaSupervisoraErrors;
    setFormErrors: (value: FormEmpresaSupervisoraErrors) => void
    setEmpresaSupervisoraForm: (value: EmpresaSupervisora) => void
    emailOriginal?: string
    edit: boolean,
    view: boolean
}

const estados = [
    { id: 'true', valor: 'ACTIVA' },
    { id: 'false', valor: 'INACTIVA' },
];

const SeccionEmpresaSupervisora = ({ empresaSupervisoraForm, setFormErrors, setEmpresaSupervisoraForm, emailOriginal, errors, edit, view }: EmpresaSupervisoraProps) => {
    const { isSistemaTipoUsuario } = useUserLogin();

    const onChangeEmpresaSupervisora = (e: any) => {
        const { name, value } = e.target;
        const nuevoForm = {
            ...empresaSupervisoraForm,
            [name]: name === 'activo' ? value === 'true' : value
        };
        setEmpresaSupervisoraForm(nuevoForm)
        setFormErrors(validateForm(nuevoForm))
    }

    const validateForm = (empresaSupervisora: EmpresaSupervisora) => {
        const errors: FormEmpresaSupervisoraErrors = {};
        if (!empresaSupervisora.nombreEmpresa) {
            errors.nombreEmpresa = "El campo Nombre Empresa es obligatorio"
        }
        if (!empresaSupervisora.email) {
            errors.email = "El campo Mail es obligatorio"
        } else if (mailConFormatoInvalido(empresaSupervisora.email, emailOriginal)) {
            errors.email = "El campo Mail no tiene un formato válido"
        }
        return errors;
    }

    return (
        <Accordion id={'EmpresaSupervisora'} title="Empresa Supervisora">
            <div className="pb-3">
                <div className="row mt-3">
                    <FormInput
                        id={'nombreEmpresa'}
                        label={'Nombre Empresa'}
                        name={'nombreEmpresa'}
                        value={empresaSupervisoraForm.nombreEmpresa || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaSupervisora}
                        errorText={errors.nombreEmpresa}
                        maxLength={255}
                    />
                    <FormInput
                        id={'email'}
                        label={'Mail'}
                        name={'email'}
                        value={empresaSupervisoraForm.email || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaSupervisora}
                        errorText={errors.email}
                        type='email'
                        maxLength={255}
                    />
                </div>
                <div className="row mt-3">
                    <FormInput
                        id={'cuit'}
                        label={'CUIT'}
                        name={'cuit'}
                        value={empresaSupervisoraForm.cuit || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaSupervisora}
                        maxLength={50}
                    />
                    <FormSelectBox
                        title={'Estado'}
                        label={'estado'}
                        id={'activo'}
                        name={'activo'}
                        onChange={onChangeEmpresaSupervisora}
                        optionId={'id'}
                        optionLabel={'valor'}
                        value={String(empresaSupervisoraForm.activo)}
                        options={estados}
                        isDisabled={(edit && view) || !isSistemaTipoUsuario()}
                    />
                </div>
            </div>
            <div className="row mt-3"></div>
        </Accordion>
    )
}

export default SeccionEmpresaSupervisora;
